/**
 * @fileoverview used for handling lead generation app pages
 * @author Kyle Temple (ktemple@yext.com)
 */

goog.module('yext.developerapps.common.LeadGen');
goog.module.declareLegacyNamespace();

const LeadField = goog.require('yext.developerapps.common.LeadField');
const DialogView = goog.require('yext.apps.common.DialogView');
const yext = goog.require('yext');
const notify = goog.require('yext.notify');

/**
 * Constructor of LeadGen
 *
 * @param {!Object} data Data model of leadgen
 * @constructor
 */
const LeadGen = function(data) {
  this.leadField = new LeadField();

  // view mode selectors
  this.$viewMode = $('.js-configure-view');
  this.$viewContactName = this.$viewMode.find('.js-view-contactName');
  this.$viewContactEmail = this.$viewMode.find('.js-view-contactEmail');
  this.$viewName = this.$viewMode.find('.js-view-name');
  this.$viewPhone = this.$viewMode.find('.js-view-phone');
  this.$viewStreetAddress = this.$viewMode.find('.js-view-streetAddress');
  this.$viewCity = this.$viewMode.find('.js-view-city');
  this.$viewState = this.$viewMode.find('.js-view-state');
  this.$viewZip = this.$viewMode.find('.js-view-zip');
  this.$viewLeadSource = this.$viewMode.find('.js-view-leadSource');
  this.$viewScanUrl = this.$viewMode.find('.js-view-scanUrl');
  this.$viewUtmSource = this.$viewMode.find('.js-view-utmSource');
  this.$viewUtmMedium = this.$viewMode.find('.js-view-utmMedium');
  this.$viewUtmCampaign = this.$viewMode.find('.js-view-utmCampaign');

  // edit mode selectors
  this.$editMode = $('.js-configure-edit');
  this.$cancel = this.$editMode.find('.js-cancel');

  // page level error
  this.$pageError = $('.js-app-description-error');

  // test lead selectors
  this.testLeadModal = new DialogView($('.js-test-lead-modal'));
  this.testLeadModal.init();
  this.$sendTestLead = $('.js-test-lead');
  this.$testLeadSubmit = $('.js-test-lead-submit');

  // step selectors
  this.$steps = $('.js-app-install-step');

  this.submitUrl = data['submitUrl'];

  // data models
  this.fields = data['fields'];
  this.fieldNamesToLabels = {}; // field name -> field label
  this.fieldLabelsToNames = {}; // field label -> field name
  for (var i = 0; i < data['fields'].length; i ++) {
    this.fieldNamesToLabels[data['fields'][i].name] = data['fields'][i].label;
    this.fieldLabelsToNames[data['fields'][i].label] = data['fields'][i].name;
  }

  // fields -> field labels
  this.labelMappings = {
    'contactName': data['contactName'],
    'contactEmail': data['contactEmail'],
    'name': data['name'],
    'phone': data['phone'],
    'streetAddress': data['streetAddress'],
    'city': data['city'],
    'state': data['state'],
    'zip': data['zip'],
    'leadSource': data['leadSource'],
    'scanUrl': data['scanUrl'],
    'utmSource': data['utmSource'],
    'utmMedium': data['utmMedium'],
    'utmCampaign': data['utmCampaign'],
  };
  // fields -> field names
  this.nameMappings = {};

  // populate nameMappings
  for (var field in this.labelMappings) {
    var fieldName = this.fieldLabelsToNames[this.labelMappings[field]];

    // If a field is not present from hubspot account, clear it from both nameMappings and labelMappings.
    // Otherwise fill in nameMappings as well.
    if (fieldName) {
      this.nameMappings[field] = fieldName;
    } else {
      this.labelMappings[field] = undefined;
      this.nameMappings[field] = undefined;
    }
  }

  this.init();
};

/**
 * init initializes bindings on LeadGen
 */
LeadGen.prototype.init = function() {
  this.bindSubmissions();
  this.bindDropdowns();
  this.bindToggleViewMode();
  this.bindAddingLeadFields();
  this.bindTestLead();
  this.updateDropdowns();
  this.bindNotifications();
};

/** @suppress {deprecated} */
LeadGen.prototype.bindTestLead = function() {
  var self = this;
  var url = $('.js-test-lead-modal').data('test-lead-url');

  this.$sendTestLead.on('click', function() {
    self.testLeadModal.show();
  });

  this.$testLeadSubmit.on('click', function() {
    $.ajax({
      method: 'POST',
      ContentType: 'application/json',
      url: url,
    }).done(function(result) {
      self.testLeadModal.hide();
      if (result['error']) {
        notify.showError(yext.msg('Failed to create test lead.'));
      } else {
        notify.showSuccess(yext.msg('A test lead has been sent to your account.'));
      }
    });
  });
};

/** @suppress {deprecated} */
LeadGen.prototype.bindNotifications = function() {
  notify.init();
};

LeadGen.prototype.bindAddingLeadFields = function() {
  var self = this;
  $(this.leadField).on('submitted', function(event, data) {
    self.updateMappings(data['source'], data['newField']);
    self.updateFields(data['totalFields']);
    self.updateDropdowns();
  });
};

/**
 * bindValidations binds mapping submissions and validations
 */
LeadGen.prototype.bindSubmissions = function() {
  var self = this;
  var url = $(this).data('submit-url');

  this.$editMode.on('click', '.js-save', function() {
    if (self.formValidated()) {
      $.ajax({
        method: 'POST',
        ContentType: 'application/json',
        data: self.nameMappings,
        url: url,
      })
        .done(function() {
          self.updateView();
          self.toggleViewMode(true);
          self.updateSteps();
        })
        .fail(function(jqXHR, textStatus) {
          self.togglePageError('Failed to save mappings');
        });
    } else {
      self.togglePageError('');
    }
  });
};

/**
 * formValidated checks if any required fields are missing
 */
LeadGen.prototype.formValidated = function() {
  var formValidated = true;
  $('.js-required').each(function() {
    if (this.value === '') {
      var $this = $(this);
      $this.closest('.js-field-wrapper').find('.js-field-error').slideDown('fast');
      $this.addClass('error');
      formValidated = false;
    }
  });
  return formValidated;
};

/**
 * togglePageError toggle displaying/hiding page level error message
 * @param {string} error
 */
LeadGen.prototype.togglePageError = function(error) {
  if (error === '') {
    this.$pageError.slideUp('fast');
  } else {
    this.$pageError.text(error).slideDown('fast');
  }
};

/**
 * bindDropdown binds dropdown
 */
LeadGen.prototype.bindDropdowns = function() {
  var self = this;
  var previous;

  this.$editMode.find('.js-field').on('focus', function() {
    previous = this.value;
  }).on('change', function() {
    var $this = $(this);
    var source = $(this).data('source');
    $this.closest('.js-field-wrapper').find('.js-field-error').slideUp('fast');
    $this.removeClass('error');
    if ($this.val() === 'add-field') {
      self.leadField.show(source);
      $this.val(previous);
    } else {
      previous = this.value;
      self.updateMappings(source, {'name': $this.val(), 'label': self.fieldNamesToLabels[$this.val()]});
      self.updateDropdowns();
    }
  });
};

/**
 * updateMappings updates leadgen mappings from a source (name, address) to a field
 */
LeadGen.prototype.updateMappings = function(source, field) {
  this.nameMappings[source] = field.name;
  this.labelMappings[source] = field.label;
};

/**
 * updateFields updates fields data model
 *
 * @param {!Object} data New fields data object
 */
LeadGen.prototype.updateFields = function(data) {
  this.fields = data;
  for (var i = 0; i < data.length; i ++) {
    this.fieldNamesToLabels[data[i].name] = data[i].label;
    this.fieldLabelsToNames[data[i].label] = data[i].name;
  }
};

/**
 * updateDropdowns rebuild fields <select>
 */
LeadGen.prototype.updateDropdowns = function() {
  var self = this;
  this.$editMode.find('.js-field').each(function() {
    var $select = $(this);
    var source = $select.data('source');
    // 1. clear options, excluding 'select a field' and 'add a field'
    $select
      .find('option')
      .not('.js-select-field')
      .not('.js-add-field').remove();

    // 2. rebuild options
    for (var i = 0; i < self.fields.length; i ++) {
      var optionUsed = false;
      $.each(self.nameMappings, function(s, n) {
        if (s !== source && n === self.fields[i].name) {
          optionUsed = true;
          return false;
        }
      });

      // skip options that are already used in other dropdowns
      if (optionUsed) {
        continue;
      }

      var $option = $('<option></option>')
        .attr('value', self.fields[i].name)
        .text(self.fields[i].label);

      if (self.fields[i].name === self.nameMappings[source]) {
        $option.attr('selected', 'selected');
      }

      $select.append($option);
    }
  });
};

/**
 * bindToggleViewMode binds listeners to toggle view/edit mode
 */
LeadGen.prototype.bindToggleViewMode = function() {
  var self = this;
  this.$viewMode.on('click', '.js-edit', function() {
    self.toggleViewMode(false);
  });

  this.$editMode.on('click', '.js-cancel', function() {
    self.toggleViewMode(true);
  });
};

/**
 * toggleViewMode toggles view/edit mode of LeadGen
 * @param {boolean} isViewMode
 */
LeadGen.prototype.toggleViewMode = function(isViewMode) {
  var self = this;
  if (isViewMode) {
    self.$editMode.fadeOut('slow', function() {
      self.$viewMode.show();
      self.$cancel.show();
    });
    self.$pageError.fadeOut('slow');
  } else {
    self.$viewMode.fadeOut('slow', function() {
      self.$editMode.show();
    });
  }
};

/**
 * updateView updates leadgen view
 *
 */
LeadGen.prototype.updateView = function() {
  this.$viewContactName.text(this.labelMappings['contactName']
    ? this.labelMappings['contactName'] : yext.msg('Not Synced'));
  this.$viewContactEmail.text(this.labelMappings['contactEmail']
    ? this.labelMappings['contactEmail'] : yext.msg('Not Synced'));
  this.$viewName.text(this.labelMappings['name']);
  this.$viewPhone.text(this.labelMappings['phone']);
  this.$viewStreetAddress.text(this.labelMappings['streetAddress'] ? this.labelMappings['streetAddress'] : yext.msg('Not Synced'));
  this.$viewCity.text(this.labelMappings['city']
    ? this.labelMappings['city'] : yext.msg('Not Synced'));
  this.$viewState.text(this.labelMappings['state']
    ? this.labelMappings['state'] : yext.msg('Not Synced'));
  this.$viewZip.text(this.labelMappings['zip']
    ? this.labelMappings['zip'] : yext.msg('Not Synced'));
  this.$viewLeadSource.text(this.labelMappings['leadSource']
    ? this.labelMappings['leadSource'] : yext.msg('Not Synced'));
  this.$viewScanUrl.text(this.labelMappings['scanUrl']
    ? this.labelMappings['scanUrl'] : yext.msg('Not Synced'));
  this.$viewUtmSource.text(this.labelMappings['utmSource']
    ? this.labelMappings['utmSource'] : yext.msg('Not Synced'));
  this.$viewUtmMedium.text(this.labelMappings['utmMedium']
    ? this.labelMappings['utmMedium'] : yext.msg('Not Synced'));
  this.$viewUtmCampaign.text(this.labelMappings['utmCampaign']
    ? this.labelMappings['utmCampaign'] : yext.msg('Not Synced'));
};

/**
 * updateSteps updates install steps view, which activates step 2.
 */
LeadGen.prototype.updateSteps = function() {
  var $step = this.$steps.eq(1);
  $step.find('.app-install-circle')
    .removeClass('inactive')
    .addClass('complete');
  $step.find('.app-step-indicator').removeClass('inactive');
  $step.find('.app-step-instructions').removeClass('inactive');
};

goog.exportSymbol('yext.developerapps.common.LeadGen', LeadGen);

exports = LeadGen;
